<script setup lang="ts">
defineOptions({
  name: "404"
});
</script>

<template>
  <ExceptionBase type="404" />
</template>

<style scoped></style>
